import {
  throwError as observableThrowError,
  forkJoin as observableForkJoin,
  Subject,
} from "rxjs";

import { catchError, map } from "rxjs/operators";
import { Injectable, ErrorHandler } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { environment } from "../../environments/environment";
import { CustomerConfig } from "../shared/interfaces";
import { KpiService } from "../kpi/kpi.service";

import * as _ from "lodash";
@Injectable()
export class JobStatusService {
  customerConfig: CustomerConfig;
  updatedCustomerConfig: CustomerConfig;
  updatedCustomerConfigChange: Subject<CustomerConfig> = new Subject<CustomerConfig>();
  hasMinDaysInputError: boolean = false;
  enrollmentWindowInputErrors: Array<boolean> = [];

  constructor(
    public http: HttpClient,
    public kpiService: KpiService,
    private rollbarErrorHandler: ErrorHandler
  ) {
    this.updatedCustomerConfigChange.subscribe((value) => {
      this.updatedCustomerConfig = value;
    });
  }

  updateCustomerConfig(customerConfig: CustomerConfig) {
    this.updatedCustomerConfigChange.next({ ...customerConfig });
  }

  getConfigForCustomer() {
    let url = `${environment.kpiServiceApi}/jobstatus/config`;
    return this.http
      .get(url, { withCredentials: true })
      .pipe(catchError((err) => this.handleError(err)));
  }

  updateConfigForCustomer(attribute, value) {
    let url = `${environment.kpiServiceApi}/jobstatus/config`;
    let body = {
      value: value,
      attribute: attribute,
      comment: "Updated via the Data Config Settings UI",
      modifiedby: this.kpiService.userInfo.email,
      dbext: "",
    };
    return this.http
      .put(url, body, { withCredentials: true })
      .pipe(catchError((err) => this.handleError(err)));
  }

  getEnrollmentWindowYears() {
    //first we pick the enrollment properties out of the object
    let customerConfigAttributes = _.keys(this.updatedCustomerConfig);
    let enrollmentWindows = _.filter(customerConfigAttributes, (w) => {
      return w.includes("EnrollmentWindow");
    });
    // then we get just the years
    let enrollmentWindowYears = _.map(
      enrollmentWindows,
      (enrollmentWindow: any) => {
        return enrollmentWindow.split(".")[1];
      }
    );
    enrollmentWindowYears = _.uniq(enrollmentWindowYears);
    enrollmentWindowYears.sort((a, b) => {
      a = a.split("-").join("");
      b = b.split("-").join("");
      return a > b ? -1 : a < b ? 1 : 0;
    });
    return enrollmentWindowYears;
  }

  hasUpdates() {
    return !_.isEqual(this.customerConfig, this.updatedCustomerConfig);
  }

  saveChanges() {
    //check each "enrollment" attribute, see if the updated customer config is different from the original
    let customerConfigAttributes = _.keys(this.updatedCustomerConfig);
    let enrollmentAttributes = _.filter(
      customerConfigAttributes,
      (w: string) => {
        return w.includes("enrollment");
      }
    );
    let observableBatch = [];
    enrollmentAttributes.forEach((element: string) => {
      //check if the attribute has changed. If so, call the save method
      if (this.updatedCustomerConfig[element] != this.customerConfig[element]) {
        observableBatch.push(
          this.updateConfigForCustomer(
            element,
            this.updatedCustomerConfig[element]
          )
        );
      }
    });
    return observableForkJoin(observableBatch);
  }

  hasEnrollmentWindowInputError() {
    return _.indexOf(_.values(this.enrollmentWindowInputErrors), true) > -1;
  }

  handleError(error) {
    console.error("error status: " + error.status);
    this.rollbarErrorHandler.handleError(error);
    return observableThrowError(error.status);
  }
}
